function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IsleOfManFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#E31D1C",
      fillRule: "evenodd",
      d: "M0 3v18h24V3H0Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("mask", {
      id: "b",
      width: "24",
      height: "18",
      x: "0",
      y: "3",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 3v18h24V3H0Z",
        clipRule: "evenodd"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#F7FCFF",
        fillRule: "evenodd",
        d: "M4.565 6.038c-.003-.046.053-.068.084-.034.295.327 1.247 1.337 1.787 1.337.645 0 3.175-2.132 3.923-1.785.748.347 2.262 3.979 2.262 3.979l-.987 1.237-1.275-.695-.353-2.32s-2.343 1.174-3.57.716l-.69.251s-.663-1.314-.925-1.716c-.19-.294-.242-.746-.256-.97Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FECA00",
        fillRule: "evenodd",
        d: "m6 9.206-.882.464.169-.982-.714-.695.986-.143L6 6.956l.44.894.987.143-.714.695.169.982L6 9.206ZM9.849 5.653a.271.271 0 0 1 .54.043l-.166 2.073a.271.271 0 1 1-.54-.043l.166-2.073Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#F7FCFF",
        fillRule: "evenodd",
        d: "M18.975 6.86c.04.021.03.08-.016.088-.433.077-1.794.35-2.08.808-.342.546.126 3.822-.565 4.272-.691.45-4.573-.19-4.573-.19l-.527-1.493 1.266-.713 2.221.885S14.912 8 15.95 7.202l.122-.764s1.466.133 1.946.125c.35-.006.76.19.958.296Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FECA00",
        fillRule: "evenodd",
        d: "m15.379 6.642.074-.993.743.663.968-.236-.401.911.524.848-.991-.1-.644.76-.212-.973-.921-.378.86-.502ZM16.465 11.399a.292.292 0 1 1-.352.468l-1.442-1.12a.265.265 0 0 1 .319-.424l1.475 1.076Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#F7FCFF",
        fillRule: "evenodd",
        d: "M11.09 18.774c-.04.024-.086-.015-.07-.058.15-.414.595-1.73.341-2.206-.302-.569-3.372-1.802-3.417-2.625-.044-.824 2.451-3.865 2.451-3.865l1.556.29-.016 1.452-2.018 1.48s2.274 1.426 2.445 2.724l.545.503s-.85 1.204-1.082 1.623c-.17.306-.544.564-.735.682Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FECA00",
        fillRule: "evenodd",
        d: "m13.42 15.686.822.56-.946.313-.279.956-.589-.803-.996.03.582-.809-.336-.937.949.303.787-.61.005.997ZM8.328 14.217a.305.305 0 0 1-.22-.568l1.513-.592a.31.31 0 1 1 .224.578l-1.517.582Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FECA00",
        d: "M10.247 10.324a.184.184 0 0 1-.111-.232c.031-.096.181-.256.274-.223l1.302.455a.183.183 0 0 1 .12.158l.117 1.428c.008.1-.139.182-.237.19a.18.18 0 0 1-.193-.167l-.107-1.228-1.165-.381Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FECA00",
        d: "M12.51 9.576c.078-.062.217.01.278.09.06.079.046.194-.031.256l-.902.924c-.078.062-.253-.059-.314-.138-.06-.08-.078-.297 0-.36l.97-.772Z"
      })]
    })]
  })]
}));
//# sourceMappingURL=IsleOfMan.js.map